import { useState, useEffect } from 'react';
import axios from 'axios';
import { analytics } from '../services/analytics';
import './AdditionalsPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.privemobility.com/api';

const AdditionalsPage = () => {
  const [additionals, setAdditionals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analytics.trackPageView('additionals_page');
    loadAdditionals();
  }, []);

  const loadAdditionals = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/additionals`);
      // Filtrar solo los activos
      const activeAdditionals = (response.data || []).filter(add => add.active);
      setAdditionals(activeAdditionals);
    } catch (error) {
      console.error('Error loading additionals:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="additionals-page">
        <div className="additionals-container">
          <div className="loading">Cargando servicios adicionales...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="additionals-page">
      <div className="additionals-container">
        <div className="additionals-header">
          <h1>Nuestros adicionales</h1>
          <p className="additionals-subtitle">Servicios y coberturas</p>
        </div>

        <div className="additionals-grid">
          {additionals.map(additional => (
            <div key={additional.id} className="additional-service-card">
              <div className="service-icon">{additional.icon}</div>
              <h3 className="service-title">{additional.name}</h3>
              <p className="service-description">{additional.description}</p>
              {additional.id === 'airportService' && (
                <p className="service-contact">
                  En caso que su requerimiento horario sea distinto a nuestros horarios de sucursal agregue este adicional y póngase en contacto con reservas@privemobility.com
                </p>
              )}
            </div>
          ))}
        </div>

        {additionals.length === 0 && (
          <div className="additionals-empty">
            <p>No hay servicios adicionales disponibles en este momento.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalsPage;
